import getBody from './getBody';
import GlobalVariables from '../GlobalVariables';

// A global singleton instance of CompanyLevelValidator
const ServerLog = {
    log: (data) => {
        try {
            if (data.level >= ApexChat.currentLogLevel) {
                const img = document.createElement('img');
                img.alt = 'Live Chat';
                img.src = `${ApexChatBaseUrl}api/loggers?
                        companyId=${data.companyId}
                        &visitorId=${data.visitorId}
                        &text=${data.text}`;
                img.style.display = 'none';
                getBody().appendChild(img);
            }
        } catch (e) {
            if (window && window.console) {
                window.console.error(e);
            }
        }
    },
    trackClick(data) {
        try {
            const img = document.createElement('img');
            img.alt = 'Live Chat';
            img.src = `${GlobalVariables.ApexChatBaseUrl}Handlers/ClickTracker.ashx?companyId=${data.companyId}&visitorId=${data.visitorId}&clickSource=${data.clickSource}&cb=${new Date().getTime()}`;
            img.style.display = 'none';
            getBody().appendChild(img);
        } catch (e) {
            if (window && window.console) {
                window.console.error(e);
            }
        }
    }
};
export default ServerLog;
